export const convertBase64Image = (data: string, type: string): string =>
  `data:${type};base64,${data}`;
